import './CompanyAddress.scss';

import React from 'react';

import { classNames } from '../../utils';

function CompanyAddress({includeName, className}) {
  return (
    <address className={classNames('company-address', className)}>
      {includeName ? <strong>Tri-Star Systems<br /></strong> : null}
      16253 Swingley Ridge Road Suite 210<br />
    Chesterfield, MO 63017<br /><br />
  <strong>Office Hours:</strong><br />
  Monday - Friday<br />
  7:00 a.m. - 5:00 p.m. Central Time<br /><br />

<strong>Holiday Schedule 2021:</strong>
  <table border="1" cellPadding="3" cellSpacing="0" className="contactTable">
  <tbody>
  <tr>
  <td>January 1</td>
  <td>New Year's Day, observance</td>
  </tr>
  <tr>
  <td>May 31</td>
  <td>Memorial Day</td>
  </tr>
  <tr>
  <td>July 5</td>
  <td>Independence Day, observance</td>
  </tr>
  <tr>
  <td>September 6</td>
  <td>Labor Day</td>
  </tr>
  <tr>
  <td>November 25</td>
  <td>Thanksgiving Day</td>
  </tr>
  <tr>
  <td>November 26</td>
  <td>Thanksgiving, extended day</td>
  </tr>
  <tr>
  <td>December 24</td>
  <td>Christmas, observance</td>
  </tr>
  <tr>
  <td>December 27</td>
  <td>Christmas, observance</td>
  </tr>
  <tr>
  <td>December 31</td>
  <td>New Year's Day, observance</td>
  </tr>
  </tbody>
  </table>
    </address>
  );
}

export default CompanyAddress;
